import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_ClientRegistration = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_ClientRegistration' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Northwest Behavioral Health Services, Inc. Registration and Financial Form (Annually)</h3></p>

                <p className='w-750'><h4>CLIENT INSURANCE INFORMATION:</h4></p>


                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name of Insurance:</span>
                        </td>

                        <td className='w-250'>
                            <span className='eleHeader'>Plan#: </span><span className='small'>(if applicable)</span>
                        </td>

                        <td className='w-250'>
                            <span className='eleHeader'>Effective Date:</span>
                        </td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameInsurance' name='txtNameInsurance' className='add-only' />
                        </td>

                        <td className='w-250'>
                            <input type='text' id='txtPlan' name='txtPlan' className='add-only' />
                        </td>

                        <td className='w-250'>
                            <input type='text' id='txtEffectiveDate' name='txtEffectiveDate' className='add-only' />
                        </td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>ID#</span>
                        </td>

                        <td className='w-250'>
                            <span className='eleHeader'>Insurance Phone Number:</span>
                        </td>

                        <td className='w-250'>
                            <span className='eleHeader'>Responsible Party </span><span className='small'>(if different than insured)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtRelationshipId' name='txtRelationshipId' className='add-only' />
                        </td>

                        <td className='w-250'>
                            <input type='text' id='txtInsurancePhoneNumber' name='txtInsurancePhoneNumber' className='add-only' />
                        </td>

                        <td className='w-250'>
                            <input type='text' id='txtResponsibleParty' name='txtResponsibleParty' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Relationship</span>
                        </td>

                        <td className='w-250'>
                            <span className='eleHeader'>Date of Birth</span>
                        </td>

                        <td className='w-250'>
                            <span className='eleHeader'>Phone Number</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtRelationship' name='txtRelationship' className='add-only' />
                        </td>

                        <td className='w-250'>
                            <input type='text' id='txtDateBirth' name='txtDateBirth' className='add-only' />
                        </td>

                        <td className='w-250'>
                            <input type='text' id='txtPhoneNumber' name='txtPhoneNumber' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Coverage:</span>
                        </td>

                        <td className='w-250'>
                            <span className='eleHeader'>SECONDARY INSURANCE COMPANY</span>
                        </td>

                        <td className='w-250'>
                            <span className='eleHeader'>Group No.</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCoverage' name='txtCoverage' className='add-only' />
                        </td>

                        <td className='w-250'>
                            <input type='text' id='txtInsurance' name='txtInsurance' className='add-only' />
                        </td>

                        <td className='w-250'>
                            <input type='text' id='txtGroupNo' name='txtGroupNo' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'><h4>PRIMARY CAREGIVER INFORMATION:</h4></p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Last Name</span>
                        </td>

                        <td className='w-250'>
                            <span className='eleHeader'>First Name</span>
                        </td>

                        <td className='w-250'>
                            <span className='eleHeader'>MI</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtLastName' name='txtLastName' className='add-only' />
                        </td>

                        <td className='w-250'>
                            <input type='text' id='txtFirstName' name='txtFirstName' className='add-only' />
                        </td>

                        <td className='w-250'>
                            <input type='text' id='txtMi' name='txtMi' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Relationship:</span>
                        </td>

                        <td className='w-250'>
                            <span className='eleHeader'>Name of Facility</span><span className='small'>(If living in ALF or other residential setting)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameRelationship' name='txtNameRelationship' className='add-only' />
                        </td>

                        <td className='w-250'>
                            <input type='text' id='txtFacility' name='txtFacility' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Contact Person and Phone Number:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtContactPerson' name='txtContactPerson' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h4>EMPLOYMENT INFORMATION/ INCOME INFORMATION:</h4></p>
                <p className='w-750'><span className='eleHeader'>Employer</span>
                    <input type='text' id='txtEmployer' name='txtEmployer' className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>What is client's employment?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployer1' id='chkEmployer1' className='add-only' value='FullTime' />Full Time
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployer2' id='chkEmployer2' className='add-only' value='PartTime' />Part Time
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployer3' id='chkEmployer3' className='add-only' value='Unemployed' />Unemployed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployer4' id='chkEmployer4' className='add-only' value='Disabled' />Disabled
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployer5' id='chkEmployer5' className='add-only' value='Student' />Student
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployer6' id='chkEmployer6' className='add-only' value='Homemaker' />Homemaker
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployer7' id='chkEmployer7' className='add-only' value='Retired' />Retired
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployer8' id='chkEmployer8' className='add-only' value='NotLaborForce' />Not in Labor Force
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkEmployer9' id='chkEmployer9' className='add-only' value='1' />Other:
                            <input type='text' id='txtEmployerOther' name='txtEmployerOther' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>What is the primary source of income/support for client or parent of client?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkIncome' id='chkIncome' className='add-only' value='1' />Wages/Salary
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkIncome1' id='chkIncome1' className='add-only' value='1' />Public Assistance
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkIncome2' id='chkIncome2' className='add-only' value='1' />Disability/SSDI
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkIncome3' id='chkIncome3' className='add-only' value='1' />Retirement/Pension/SSI
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkIncome4' id='chkIncome4' className='add-only' value='1' />None
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkIncome5' id='chkIncome5' className='add-only' value='1' />Other
                            <input type='text' id='txtEmployerOther1' name='txtEmployerOther1' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><span className='eleHeader'>Estimated Gross Monthly Household Income</span>
                    <input type='text' id='txtGross' name='txtGross' className='add-only' /> <br />
                    <input type='checkbox' name='chkGross' id='chkGross' className='add-only' value='1' />No Income
                </p>
                <p className='w-750'><span className='eleHeader'>a. What is the total number of people dependent upon household income?</span>
                    <input type='text' id='txtGross1' name='txtGross1' className='add-only' />
                </p>
                <p className='w-750'><span className='eleHeader'>b. How many children ages 0-17 that are dependent upon the household income?</span>
                    <input type='text' id='txtGross2' name='txtGross2' className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Payment Source:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPayment' id='chkPayment' className='add-only' value='1' />Medicaid
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPayment1' id='chkPayment1' className='add-only' value='1' />LSF Funding
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPayment2' id='chkPayment2' className='add-only' value='1' />Grief & Trauma Grant
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkPayment3' id='chkPayment3' className='add-only' value='1' />Victim Services Compensation
                        </td>
                        <td className='w-750'>
                            <input type='checkbox' name='chkPayment4' id='chkPayment4' className='add-only' value='1' />(CJRG) Criminal Justice Reinvestment Grant
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkPayment5' id='chkPayment5' className='add-only' value='1' />Medicare- Therapy/Psychiatric Services
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkPayment6' id='chkPayment6' className='add-only' value='1' />Non-Funded (not eligible any payor source funding Services)
                        </td>
                    </tr>
                </table>
                <p className='w-750'>(If client income is below the Federal Poverty Guideline, no fee is assessed)</p>
                <p className='w-750'><span className='eleHeader'>Co-Payment Amount </span>
                    <span className='small'>(Due each Visit):</span>

                    <input type='text' id='txtPaymentAmount' name='txtPaymentAmount' className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Physician Services:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Psychiatric Evaluation:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            $ &nbsp;<input type='text' placeholder='' id='txtPhysicianServices1' name='txtPhysicianServices1' className='add-only w-350 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            $ &nbsp;<input type='text' id='txtPhysicianServices2' name='txtPhysicianServices2' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Other Psychiatric Services:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Psychological Testing:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            $ &nbsp;<input type='text' id='txtPhysicianServices3' name='txtPhysicianServices3' className='add-only w-350 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            $ &nbsp;<input type='text' id='txtPhysicianServices4' name='txtPhysicianServices4' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Therapeutic Services:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            $ &nbsp;<input type='text' id='txtPhysicianServices5' name='txtPhysicianServices5' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h4>Full Fee List:</h4></p>
                <table>
                    <tr>
                        <td className='w-500'>Psychiatric Evaluation
                        </td>
                        <td className='w-250'>$300.00
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>Bio-Psychosocial Evaluation
                        </td>
                        <td className='w-250'>$200.00
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>Other Psychiatric Services
                        </td>
                        <td className='w-250'>$60.00 per session
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>Psychological Testing:
                        </td>
                        <td className='w-250'>$500.00 per test
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>Psychotherapy/Individual Non-physician (Mobile)
                        </td>
                        <td className='w-250'>$150.00 per session
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>Psychotherapy/Individual Non-physician (In-Office)
                        </td>
                        <td className='w-250'>$100.00 per session
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>Group Psychotherapy
                        </td>
                        <td className='w-250'>$ 35.00 per group
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h3>AGREEMENT AND ASSIGNMENT OF BENEFITS</h3></p>
                <p className='w-750'>
                    <input type='checkbox' name='chkPaymentBenifit' id='chkPaymentBenifit' className='add-only' value='1' />
                    I agree to be financially responsible and pay for the services provided to me by Northwest Behavioral Health Services, Inc. if the services are not covered or fully paid by insurance. I understand that the law allows Northwest Behavioral Health Services, Inc. to collect from me the amount owing. If I have health insurance, I hereby authorize Northwest Behavioral Health Service, Inc. to furnish all applicable information required by the insurance company(ies) for payment of claims. I hereby assign Northwest Behavioral Health Service, Inc. all monies to which I am entitled from insurance, for expense related to the services received from Northwest Behavioral Health Services, Inc.
                </p>

            </div>
        </form>

    )
}

